import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs, profile } from '../mock';
import { MessageCircle } from 'lucide-react';

const FAQSection = () => {
  return (
    <section id="faq" className="py-24 lg:py-32 bg-[#E8DDC8]">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <span className="divider-mark" />
            <span className="eyebrow">Preguntas frecuentes</span>
          </div>
          <h2 className="font-serif text-[40px] lg:text-[52px] leading-[1.05] text-[#2E2A23] tracking-[-0.02em]">
            Antes de
            <span className="italic text-[#B8806E]"> empezar.</span>
          </h2>
          <p className="mt-6 text-[15.5px] leading-[1.75] text-[#2E2A23]/75 font-light">
            Algunas dudas habituales de quienes se acercan por primera vez. Si
            la tuya no está acá, escribíme: respondo personalmente.
          </p>
          <a
            href={profile.whatsapp}
            target="_blank"
            rel="noreferrer"
            className="btn-primary mt-8"
          >
            <MessageCircle size={16} strokeWidth={1.6} />
            Escribime tu duda
          </a>
        </div>

        <div className="lg:col-span-7">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-[#CDBE9C] data-[state=open]:bg-[#FAF4E8]/60 px-1 rounded-md"
              >
                <AccordionTrigger className="text-left font-serif text-[19px] lg:text-[22px] text-[#2E2A23] hover:text-[#B8806E] hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[15px] leading-[1.75] text-[#2E2A23]/80 pb-6 pr-4">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
